
import MessageContent from "./content/MessageContent";
import OfferDetailsCard from "./content/OfferDetailsCard";
import ResponseStrategySection from "./content/ResponseStrategySection";
import UrgencyNotice from "./content/UrgencyNotice";
import LegalContextSection from "./content/LegalContextSection";

interface MessageCardContentProps {
  content: string;
  isLatestMessage?: boolean;
  isLatestAIMessage?: boolean;
  metadata?: {
    refundApproved?: boolean;
    urgencyNotice?: string;
    legalContext?: string;
    customInstructions?: string;
    suggestedTone?: string;
  };
  amount?: number;
  onResponseStrategySelect?: (strategy: "accept" | "negotiate" | "decline") => void;
}

const MessageCardContent = ({ 
  content,
  isLatestMessage = false,
  isLatestAIMessage = false,
  metadata,
  amount = 0,
  onResponseStrategySelect
}: MessageCardContentProps) => {
  return (
    <div className="space-y-3 px-4 py-3">
      {/* Urgency notice component */}
      {metadata?.urgencyNotice && (
        <UrgencyNotice message={metadata.urgencyNotice} />
      )}
      
      {/* Offer details component */}
      <OfferDetailsCard
        refundApproved={metadata?.refundApproved}
        amount={amount}
        customInstructions={metadata?.customInstructions}
      />
      
      {/* Main message content */}
      <MessageContent 
        content={content}
        isLatestMessage={isLatestMessage}
      />
      
      {/* Legal context section if available */}
      {metadata?.legalContext && (
        <LegalContextSection content={metadata.legalContext} />
      )}
      
      {/* Response strategy section for AI messages */}
      {isLatestAIMessage && onResponseStrategySelect && metadata?.refundApproved !== undefined && (
        <ResponseStrategySection
          isLatestAIMessage={isLatestAIMessage}
          refundApproved={metadata.refundApproved}
          onResponseStrategySelect={onResponseStrategySelect}
        />
      )}
    </div>
  );
};

export default MessageCardContent;
